
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const FinalCTASection = () => {
  return (
    <div className="py-24 px-6 bg-gradient-to-b from-black to-purple-900/20">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
          Ready to Sell Out Your Next Event?
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
          Join thousands of promoters already using NocheLoco to grow their events
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Button
            size="lg"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full px-8 shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] transition-all duration-300"
            asChild
          >
            <Link to="/auth">
              Sign Up & Start Selling Tickets
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="bg-gray-900/50 text-white border-2 border-purple-500/30 rounded-full px-8 hover:bg-gray-900 hover:border-purple-500/50 shadow-[0_0_30px_rgba(168,85,247,0.1)] hover:shadow-[0_0_30px_rgba(168,85,247,0.2)] transition-all duration-300"
            asChild
          >
            <Link to="/auth">Book a Demo</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
